export default "<p>board-user works!</p>\n"